<template>  
    <div>
        <NavBarLight></NavBarLight>
        <div class="content-start">
            <div class="container-fluid" id="main-container">
                <div class="row" id="challenge-content">
                    <div class="col-md-3 text-left" id="profile-section">
                        <div class="profile-card" id="myCard">
                            <div class="text-right">
                                <span id="edit-icon" v-on:click="editInfo()"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></span>
                            </div>

                            <div class="text-center photo">
                                <img :src="photoURL" alt="" class="rounded-circle" id="photo" />
                            </div>

                            <div class="text-center name" id="name">
                                <b><h4 id="name">{{name}}</h4></b>
                            </div>

                            <div v-if="title !== ''" class="text-center title" id="title">
                                {{title}}
                            </div>

                            <div v-if="skills !== null" class="text-center">
                                <ul class="text-center" id="skills-list">
                                    <li v-for = "skill in skills" :key="skill" class="skill">
                                        {{skill}}
                                    </li>
                                </ul>
                                
                            </div>
                            
                            <div class="text-center" id="link">
                                <span class="each-link" v-if="linkedinURL !== ''" v-on:click="linkClicked(linkedinURL)"><img src='@/assets/brand-logos/linkedin.png' class="logo" /></span>
                                <span class="each-link" v-if="dribbbleURL !== ''" v-on:click="linkClicked(dribbbleURL)"><img src='@/assets/brand-logos/dribbble.svg' class="logo" /></span>
                                <span class="each-link" v-if="behanceURL !== ''" v-on:click="linkClicked(behanceURL)"><img src='@/assets/brand-logos/behance.png' class="logo" /></span>
                                <span class="each-link" v-if="githubURL !== ''" v-on:click="linkClicked(githubURL)"><img src='@/assets/brand-logos/github.png' class="logo" /></span>
                                

                            </div>

                            <div v-if="empty && loadedFB" class="text-center">
                                <div class="message text-left"><i class="fa fa-exclamation-triangle"></i>Please complete your profile to connect with companies</div><br>
                                <a id="title-btn" v-on:click="editInfo()" class="btn btn-outline-success">COMPLETE PROFILE</a>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-md-9 text-left" id="submissions-section">
                        <b-tabs content-class="mt-3" justified>
                            <b-tab title="Courses" active tabindex="-1">
                                <div class="container">
                                    <div class="row">              
                                        <LearnCard v-for ="course in courses" :key="course['.key']" class="course-card"
                                            v-bind:level = "course.level"
                                            v-bind:skill = "course.skill"
                                            v-bind:link = "course.link"
                                            v-bind:platform = "course.platform"
                                            v-bind:iconUrl = "course.iconUrl"
                                            v-bind:slug="course['.key']">
                                        </LearnCard>      
                                    </div>
                                </div>
                        
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>


<script>
import NavBarLight from '@/components/NavBarLight.vue'
import firebase from '../services/firebase'
import ContentCard from '@/components/ContentCard.vue'
import LearnCard from '@/components/LearnCard.vue'


export default {
    name: 'Profile',
    components: {
        NavBarLight,
        ContentCard,
        LearnCard
    }, 
    data: function() {
        return {
            title: '',
            skills: null,
            submissions: null,
            name: '',
            photoURL: '',
            behanceURL: '',
            githubURL: '',
            linkedinURL: '',
            dribbbleURL: '',
            mediumURL: '',
            truncBehance: '',
            truncLinkedin: '',
            truncDribbble: '',
            truncMedium: '',
            loadedFB: false,
            courses: null
        }
    },

    methods: {
        editInfo: function() {
            this.$router.push(this.$route.path + '/update');
        },
        linkClicked: function(url) {
            window.location.href = url;
        },
        getUserId: function() {
            return this.user_id;
        },
        getDate: function(ts) {
            var options = {year: 'numeric', month: 'long', day: 'numeric' };
            return new Date(ts).toLocaleDateString("en-us", options);
        },
        cardClicked: function() {
            
        }
    },

    computed: {
        empty: function() {
            if (this.behanceURL === '' && 
            this.linkedinURL === '' && this.dribbbleURL === '' && this.githubURL === '') {
                return true;
            } else {
                return false;
            }
        },
        platformCourses: function() {
            var list = [];
            list = this.courses;
            console.log('list is ' + list);
        

            list.forEach(element => {
                console.log('element key is ' + element['.key']);
                console.log('domain is ' + element.domain);
                var domain = element.domain.replace('-', '_');
                console.log('new domain is ' + domain);

                if (element.signedUp) {
                    firebase.database().ref(domain + '/' + element['.key']).once('value').then((course) => {
                        console.log('course name is ' + course.val().name);
                        console.log('course duration is ' + course.val().duration);
                    
                    }); 
                }
            });
        }
    },

    created: function() {
        firebase.auth().onAuthStateChanged((logged_in_user) => {
            if (logged_in_user) {         
                this.name = logged_in_user.displayName;
                this.photoURL = logged_in_user.photoURL;
                this.$bindAsArray('submissions', firebase.database().ref('user_submissions/' + logged_in_user.uid));
                this.$bindAsArray('courses', firebase.database().ref('users/' + logged_in_user.uid + '/courses/'));
                firebase.database().ref('users/' + logged_in_user.uid).once('value').then((user) => {  
                    this.title = user.val().headline;
                    var skills = user.val().skills;
                    if (skills !== undefined) {
                        skills = skills.split(",");
                        this.skills = skills;
                    }
                    
                    if (user.val().behance !== undefined) {
                        this.behanceURL = user.val().behance;
                    }
                        
                    if (user.val().linkedin !== undefined) {
                        this.linkedinURL = user.val().linkedin;
                    }
                    
                    if (user.val().github !== undefined) {
                        this.githubURL = user.val().github;
                    }
                    
                    if (user.val().dribbble !== undefined) {
                        this.dribbbleURL = user.val().dribbble;
                    }
                    


                    //Truncate links

                    this.loadedFB = true;
                    
                });
            } 
        });
    }
}
</script>


<style scoped>

    @import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");

    .content-start {
        margin-top:58px;
    }

    #main-container {
        color:#222;
        background-color:#f8faff !important;
    }

    #challenge-content {
        margin-left:2%;
        margin-right:2%;
        padding-right:0%;
    }

    .profile-card {
		margin-top:10px; 
		margin-bottom:80px; 
        padding: 20px;
        border-radius: 10px;
		border:none;
		box-shadow: 2px 1px 2px 0px rgba(46,61,73,0.15);
        transition: all 0.3s ease;
		font-family: Helvetica;
        background-color: #fff;
	}

    .course-card {
        width: 40%;
    }

    .card {
		margin-top:20px; 
		margin-bottom:20px; 
        padding-bottom:10px;
		margin-right: 6.25%;
		margin-left: 6.25%;
		border:none;
		box-shadow: 2px 1px 2px 0px rgba(1, 2, 2, 0.15);
        transition: all 0.3s ease;
		font-family: Helvetica;
		cursor:pointer;
		border-radius: 10px;
        color: #444;
	}

    .fa.fa-pencil-square-o {
        font-size:16px;
        color:#999;
        margin-right:15px;
        cursor: pointer;
    }

    .fa.fa-exclamation-triangle {
        margin-right:10px;
    }

    #photo {
        height:75px; 
        width:75px;
        margin-bottom:20px;
    }

    #name {
        margin-bottom:20px;
    }

    #title {
        margin-bottom:20px;
    }

    #skills-list {
		list-style-type: none;
		display: inline-block;
	}

    .skill {
		border-color:#ccc;
		border-radius: 6px;
		margin-left:3px;
		margin-right:3px;
		margin-top:8px;
		margin-bottom:8px;
		border-style: solid;
		border-width: 1px;
		padding:2px 12px;
		font-size:13px;
		display:inline-block;
        color:#555;
	}

    #skills-list {
        list-style-type: none;
        display: inline-block;
    }

    ul {
        padding-inline-start: 0px;
    }


    .logo {
        height:28px;
        width:28px;
        padding-bottom:2px;
        margin-right: 10px;
    }

    #title-btn {
		color:#f25792;
		border-color:#f25792;
		background-color: #fff;
		width:50%;
		font-size:0.75rem;
        cursor:pointer;
        border-radius: 7px;
        padding-top:2.3%;
        padding-bottom:2.3%;
	}

	#title-btn:hover {
		color:#f25792;
		border-color:#f25792;
		background-color: #fff;
	}

    .message {
        padding-left:10%;
        padding-right:0%;
        margin-top:20px;
        font-size:0.8em;
        color:#888;
    }

    .link {
        color: #777;
        font-size: 0.9em;
        margin-left: 30%;
        padding-left: 20px;
        margin-right: 20px;
        margin-top:10px;
    }

    #link {
        margin-top: 30px;
        margin-bottom:20px;
        margin-left: 10%;
        margin-right: 10%;
    }

    .each-link {
        margin-left: 10px;
        margin-right: 10px;
    }

    #submissions-section {
        padding-left: 8%;
        margin-top: 10px;
    }

    @media(min-width:769px) {
        .submission-card {
            display: inline-block;
            width:45%;
            margin-right: 5%;
            cursor:pointer;
        }
    }

    @media(min-width:600px) and (max-width:768px) {
        .submission-card {
            display: inline-block;
            width:50%;
            margin-right: 5%;
            cursor:pointer;
        }
    }

    @media (min-width:420px) and (max-width:600px) {
        .submission-card {
            display: inline-block;
            width:70%;
            margin: auto;
            cursor:pointer;
        }
    }

    @media (max-width:420px) {
        .submission-card {
            display: inline-block;
            width:85%;
            margin: auto;
            cursor:pointer;
        }
    }

    

</style>
